import { render, staticRenderFns } from "./install_release.vue?vue&type=template&id=9ab74a74&scoped=true"
import script from "./install_release.vue?vue&type=script&lang=js"
export * from "./install_release.vue?vue&type=script&lang=js"
import style0 from "./install_release.vue?vue&type=style&index=0&id=9ab74a74&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab74a74",
  null
  
)

export default component.exports